var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex justify-content-center no-data"},[_c('img',{staticClass:"img-fluid",attrs:{"max-width":"600","src":require("@/assets/media/images/Icons/no-data.gif"),"alt":""}})])
}]

export { render, staticRenderFns }